import React from 'react';
import styles from './HeroSection.module.css';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';
import image from './images/assets.png';

const HeroSection = () => {
    return (
        <div className={styles.container}>
            <div className={styles.heroCard}>
                <div className={styles.backgroundEffects}>
                    <div className={styles.blurTopLeft} />
                    <div className={styles.blurBottomRightLarge} />
                    <div className={styles.blurBottomLeft} />
                    <div className={styles.blurRightPink} />
                    <div className={styles.blurTopLeftPink} />
                    <div className={styles.blurBottomCenterPink} />
                    <div className={styles.blurRightSmallYellow} />
                    <div className={styles.backgroundPattern} />
                </div>

                <div className={styles.content}>
                    <div className={styles.leftContainer}>
                        <OptimizedMotionH1
                            className={styles.mainHeading}
                            type="slide-down"
                            delay={0.2}
                        >
                            <span className={styles.gradientText}>One Source</span>
                            <br />
                            <span className={styles.gradientText}> of Truth</span>
                        </OptimizedMotionH1>
                        <div className={styles.descriptionContainer}>
                            <OptimizedMotionP
                                className={styles.description}
                                type="slide-up"
                                delay={0.4}
                            >
                                No more "final_v7_reallyFINAL" files. SimpleeCreate stores every
                                draft, asset, and comment in a single, time‑stamped thread.
                                Stakeholders always know which version is current—and which edits
                                came from whom.
                            </OptimizedMotionP>
                        </div>
                    </div>
                    <div className={styles.rightContainer}>
                        <img src={image} alt="hero" className={styles.heroImage} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroSection;
